import _ from "lodash";
import $RefParser from "@apidevtools/json-schema-ref-parser";

export function normalize(path) {
	return _.trimStart(path, "/");
}

export function $ref(path) {
	let p = path;

	// Trim leading slash
	p = normalize(p).replace(/ $/, " ~");

	// Replace special chars reserved by Json Ref
	p = _.replace(p, /~/g, "~0");
	p = _.replace(p, /\//g, "~1");

	return { $ref: `#/paths/${p}` };
}

export function $deref(obj) {
	return $RefParser.dereference(obj, { continueOnError: true });
}
